module.exports = __webpack_public_path__ + "img/logo.077f36fa.png";